export default {
  namespaced: true,

  state: {
    recovery: undefined
  },

  mutations: {
    set(state, recovery) {
      state.recovery = recovery;
    },

    /**
     * Replace a single escalation section on the stored recovery, so that the
     * escalation subpages show the saved values when they are revisited.
     */
    setEscalationSection(state, { key, data }) {
      if (state.recovery) {
        state.recovery = { ...state.recovery, [key]: data };
      }
    },

    clearRecord(state) {
      state.recovery = undefined;
    }
  },

  getters: {
    get(state) {
      return state.recovery;
    }
  }
};
